import { render } from "./Dypq.vue?vue&type=template&id=1199f3ab&scoped=true"
import script from "./Dypq.vue?vue&type=script&lang=js"
export * from "./Dypq.vue?vue&type=script&lang=js"

import "./Dypq.vue?vue&type=style&index=0&id=1199f3ab&lang=less&scoped=true"

import exportComponent from "C:\\Users\\徐永哲\\Desktop\\银商北分远程办公系统\\wx-wl_full_II\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1199f3ab"]])

export default __exports__